import APCreateAccount from './APCreateAccount';
import ListUsers from './ListUsers';
import AdminUser from './AdminUser';

window.Vue.component('ApCreateAccount', APCreateAccount);
window.Vue.component('ListUsers', ListUsers);
window.Vue.component('AdminUser', AdminUser);
